export const GIFT_CARD = 'GIFT_CARD';
export const VOUCHER = 'VOUCHER';
export const MEAL_PLAN = 'Meal plan';
export const DAILY = 'Daily';
export const MONTHLY = 'Monthly';
export const WEEKLY = 'Weekly';
